import {useState, FC} from 'react';
import TwoStepAuthenticationDisableStep1 from './TwoStepAuthenticationDisableStep1';
import TwoStepAuthenticationDisableStep2 from './TwoStepAuthenticationDisableStep2';

export interface TwoStepAuthenticationDisableProps {
  onCloseModal: () => void;
}

export enum Steps {
  CONFIRM = 1,
  SUCCESS = 2,
}

const TwoStepAuthenticationDisable: FC<TwoStepAuthenticationDisableProps> = ({onCloseModal}) => {
  const [step, setFormStep] = useState(Steps.CONFIRM);

  switch (step) {
    case Steps.CONFIRM:
      return <TwoStepAuthenticationDisableStep1 setStep={setFormStep} onClose={onCloseModal} />;

    case Steps.SUCCESS:
      return <TwoStepAuthenticationDisableStep2 onClose={onCloseModal} />;

    default: {
      return <TwoStepAuthenticationDisableStep1 setStep={setFormStep} onClose={onCloseModal} />;
    }
  }
};

export default TwoStepAuthenticationDisable;
